/**
 * @generated SignedSource<<5703095f3c2e041ab1e67d721cadd065>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventTeam_team$data = {
  readonly color: string | null;
  readonly icon: TeamIcon | null;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
  readonly " $fragmentType": "TodoTimelineUpdateEventTeam_team";
};
export type TodoTimelineUpdateEventTeam_team$key = {
  readonly " $data"?: TodoTimelineUpdateEventTeam_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventTeam_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventTeam_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIcon"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "bb8dda2d2c6e985d8a9117c27f43afd6";

export default node;
